module.exports = __webpack_public_path__ + "img/1-1.dd9dcbd9.svg";